/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'activities_expense_committed_description': '',
    'activities_expense_committed_title': 'Ausgabe festgeschrieben',
    'activities_expense_created_description': '',
    'activities_expense_created_title': 'Ausgabe erstellt',
    'activities_expense_payment_created_description': 'Zahlung über {amount} hinzugefügt.',
    'activities_expense_payment_created_title': 'Zahlung erfasst',
    'activities_expense_updated_description': '',
    'activities_expense_updated_title': 'Ausgabe aktualisiert',
    'activities_importedinvoice_created_description': '',
    'activities_importedinvoice_created_title': 'Rechnung importiert',
    'activities_invoice_committed_description': '',
    'activities_invoice_committed_title': 'Rechnung festgeschrieben',
    'activities_invoice_created_description': '',
    'activities_invoice_created_title': 'Rechnung erstellt',
    'activities_invoice_email_failed_description': 'Die E-Mail an {address} konnte nicht zugestellt werden.',
    'activities_invoice_email_failed_title': 'Zustellung gescheitert',
    'activities_invoice_email_sent_description': 'Rechnung per E-mail versandt an {recipient}.',
    'activities_invoice_email_sent_title': 'E-Mail versandt',
    'activities_invoice_generated_description': '',
    'activities_invoice_generated_title': 'Wiederkehrende Rechnung erstellt',
    'activities_invoice_payment_created_description': 'Zahlung über {amount} hinzugefügt.',
    'activities_invoice_payment_created_title': 'Zahlung erfasst',
    'activities_invoice_payment_deleted_description': 'Zahlung über {amount} gelöscht.',
    'activities_invoice_payment_deleted_title': 'Zahlung gelöscht',
    'activities_invoice_status_changed_description': 'Status der Rechnung wurde auf "{status}" geändert.',
    'activities_invoice_status_changed_title': 'Status geändert',
    'activities_invoice_updated_description': 'Die Rechnung wurde aktualisiert.',
    'activities_invoice_updated_title': 'Rechnung aktualisiert',
    'activities_quote_committed_description': '',
    'activities_quote_committed_title': 'Angebot festgeschrieben',
    'activities_quote_created_description': '',
    'activities_quote_created_title': 'Angebot erstellt',
    'activities_quote_email_failed_description': 'Die E-Mail an {address} konnte nicht zugestellt werden.',
    'activities_quote_email_failed_title': 'Zustellung gescheitert',
    'activities_quote_email_sent_description': 'Angebot per E-mail versandt an {recipient}.',
    'activities_quote_email_sent_title': 'E-Mail versandt',
    'activities_quote_status_changed_description': 'Status des Angebotes wurde auf "{status}" geändert.',
    'activities_quote_status_changed_title': 'Status geändert',
    'activities_quote_updated_description': 'Das Angebot wurde aktualisiert.',
    'activities_quote_updated_title': 'Angebot aktualisiert',
    'invoice_email_sent_label': 'Rechnung #{invoice} per E-Mail versendet',
    'last_activities': 'Letzte Aktivitäten'
  },

  /* english */
  en: {
    'activities_expense_committed_description': '',
    'activities_expense_committed_title': 'Expense committed',
    'activities_expense_created_description': '',
    'activities_expense_created_title': 'Expense created',
    'activities_expense_payment_created_description': 'Added payment of {amount}.',
    'activities_expense_payment_created_title': 'Payment added',
    'activities_expense_updated_description': '',
    'activities_expense_updated_title': 'Expense updated',
    'activities_importedinvoice_created_description': '',
    'activities_importedinvoice_created_title': 'Invoice imported',
    'activities_invoice_committed_description': '',
    'activities_invoice_committed_title': 'Invoice committed',
    'activities_invoice_created_description': '',
    'activities_invoice_created_title': 'Invoice created',
    'activities_invoice_email_failed_description': 'The email to {address} could not be delivered.',
    'activities_invoice_email_failed_title': 'Delivery failed',
    'activities_invoice_email_sent_description': 'Invoice email sent to {recipient}.',
    'activities_invoice_email_sent_title': 'Email sent',
    'activities_invoice_generated_description': '',
    'activities_invoice_generated_title': 'Recurring invoice created',
    'activities_invoice_payment_created_description': 'Added payment of {amount}.',
    'activities_invoice_payment_created_title': 'Payment added',
    'activities_invoice_payment_deleted_description': 'Deleted payment of {amount}.',
    'activities_invoice_payment_deleted_title': 'Payment deleted',
    'activities_invoice_status_changed_description': 'Invoice status was changed to "{status}".',
    'activities_invoice_status_changed_title': 'Status changed',
    'activities_invoice_updated_description': 'The invoice was updated.',
    'activities_invoice_updated_title': 'Invoice updated',
    'activities_quote_committed_description': '',
    'activities_quote_committed_title': 'Quote committed',
    'activities_quote_created_description': '',
    'activities_quote_created_title': 'Quote created',
    'activities_quote_email_failed_description': 'The email to {address} could not be delivered.',
    'activities_quote_email_failed_title': 'Delivery failed',
    'activities_quote_email_sent_description': 'Quote email sent to {recipient}.',
    'activities_quote_email_sent_title': 'Email sent',
    'activities_quote_status_changed_description': 'Quote status was changed to "{status}".',
    'activities_quote_status_changed_title': 'Status changed',
    'activities_quote_updated_description': 'The quote was updated.',
    'activities_quote_updated_title': 'Quote updated',
    'invoice_email_sent_label': 'Invoice #{invoice} sent by e-mail',
    'last_activities': 'Last Activities'
  }
}
